/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ContentEditableEvent } from 'react-contenteditable';
import { RichText } from '../interfaces/data-types';
import { EditableField, FieldType, ITextEditProps } from './editable-fields/editable-field';

export interface IRichText {
    text?: RichText;
    className?: string;
    editProps?: ITextEditProps;
}

export function getRichTextHtml(text?: RichText): { __html: string } | undefined {
    return text ? { __html: text as string } : undefined;
}

/**
 * Rich text interactive component
 */
export class RichTextComponent extends React.Component<IRichText> {
    constructor(props: IRichText) {
        super(props);
        this.state = { html: props.text };
    }

    public render = (): JSX.Element => {
        return (
            <EditableField
                onChange={this.props.editProps ? this.props.editProps.onEdit : this.onEdit} // handle innerHTML change
                requestContext={this.props.editProps && this.props.editProps.requestContext}
                fieldProps={{
                    text: this.props.text as string,
                    className: this.props.className
                }}
                type={FieldType.RichText}
            />
        );
    };

    private onEdit = (event: ContentEditableEvent) => null;
}
